export default __webpack_public_path__ + "static/media/minicard2.a758d767.jpg";